module.exports = __webpack_public_path__ + "static/media/pic4.4f41fb09.jpg";